import ForgotPasswordResetForm from "./ForgotPasswordResetForm";

export default ForgotPasswordResetForm;
